// extracted by mini-css-extract-plugin
export var planCard = "_s8-0";
export var planList = "_s8-1";